module.exports = {"title":"user_login","type":"object","properties":{"email":{"type":"string","pattern":"^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$"},"password":{"type":"string"}},"required":["email","password"]}


//////////////////
// WEBPACK FOOTER
// ./src/shared/json_schemas/userLoginForm.json
// module id = 706
// module chunks = 0